module.exports = __webpack_public_path__ + "img/connect-with-strava.d83ae0ff.png";